import script from "./StatisticBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticBlock.vue?vue&type=script&setup=true&lang=js"

import "./StatisticBlock.vue?vue&type=style&index=0&id=2d777334&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d777334"]])

export default __exports__